<!-- <div mat-dialog-title>
  <h2>{{"general.Crop Image" | translate}}</h2>

  <button mat-icon-button class="close" mat-dialog-close>
    <mat-icon class="pop-close">close</mat-icon>
  </button>
</div> -->
<section class="create">
  <div class="create_title">Crop Image</div>
  <div cdkFocusInitial class="close-dialog" mat-dialog-close>
    <mat-icon>close</mat-icon>
  </div>
  <mat-dialog-content>
    <div class="create_content">

      <div *ngIf='!showCropper' class="dataLoading py-5">
        <mat-spinner class="m-auto" diameter="30"></mat-spinner>
      </div>

      <div [hidden]="!showCropper">
        <image-cropper [maintainAspectRatio]="true" [aspectRatio]="data.ratio" [onlyScaleDown]="true"
          [resizeToWidth]="900" [imageFile]="data.image" [(transform)]="transform" (imageCropped)="imageCropped($event)"
          (imageLoaded)="imageLoaded()"></image-cropper>

        <div class="my-3 text-center">
          <button mat-icon-button (click)="zoomOut()"><mat-icon>zoom_out</mat-icon></button>
          <button mat-icon-button (click)="zoomIn()"><mat-icon>zoom_in</mat-icon></button>
        </div>
      </div>

    </div>
  </mat-dialog-content>

  <mat-dialog-actions>
    <button mat-button class="btn-grey" mat-dialog-close>Cancel</button>
    <button mat-button (click)="saveImage()" mat-raised-button color="primary">
      Ok
    </button>
  </mat-dialog-actions>
</section>